<template>
	<section class="events">
		<div class="container">
			<h2 class="events__headline">{{ $t("home.slider.headline") }}</h2>
			<span class="events__description">{{ $t("home.slider.subheadline") }}</span>
			<div class="row">
				<div class="col-1">
					<div class="events__arrow-wrapper events__arrow-wrapper--prev">
						<button class="events__arrow events__arrow--left" @click="handleCarouselPrev"></button>
					</div>
				</div>

				<div class="col-10">
					<div class="events__wrapper owl-carousel" ref="carousel">
						<EventTileComponent
							v-for="event in events"
							:key="event.id"
							:event="event"
						/>
					</div>
				</div>

				<div class="col-1">
					<div class="events__arrow-wrapper events__arrow-wrapper--next">
						<button class="events__arrow events__arrow--right" @click="handleCarouselNext"></button>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="offset-1 col-10">
					<router-link :to="{name: 'EventsList'}" class="events__btn">{{ $t("home.slider.button") }}</router-link>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	import EventTileComponent from './Event/EventTileComponent'
	import axios from 'axios'

	const EVENTS_SLIDER_ENDPOINT = '/api/events/slider/'

	export default {
		components: {
			EventTileComponent
		},
		data () {
			return {
				events: []
			}
		},
		methods: {
			handleCarouselNext () {
				if (this.owl) {
					this.owl.trigger('next.owl.carousel')
				}
			},
			handleCarouselPrev () {
				if (this.owl) {
					this.owl.trigger('prev.owl.carousel')
				}
			},
			createSlider () {
				if (!$) return

				this.owl = $(this.$refs.carousel).owlCarousel({
					items: 4,
					loop: true,
					dots: false,
					responsive: {
						0: {
							items: 1,
							margin: 16
						},
						768: {
							items: 2,
							margin: 16
						},
						1024: {
							items: 3,
							margin: 24
						},
						1170: {
							items: 4,
							margin: 24
						}
					}
				})
			},
			fetchEvents () {
				return axios.get(EVENTS_SLIDER_ENDPOINT)
			}
			// fetchEvents () {
			// 	return new Promise((resolve, reject) => setTimeout(() => {
			// 		const MONTHS = ['March', 'April', 'May', 'June', 'July', 'August']
			// 		const NAMES = ['XXXII Wystawa Psów Rasowych 1,2,4 grupy FCI', 'World Dog Show']
			// 		const RANGES = ['International', 'Club', 'National']
			//
			// 		const getRandom = array => array[Math.floor((Math.random() * 10) % (array.length))]
			//
			// 		const events = Array(8)
			// 			.fill({
			// 				photo: '/static/img/placeholder.jpg',
			// 				date: '25-28',
			// 				month: 'August',
			// 				city: 'Nowy Dwór Mazowiecki',
			// 				country: 'Poland',
			// 				distance: '55',
			// 				name: 'XXXII Wystawa Psów Rasowych 1,2,4 grupy FCI',
			// 				range: 'National'
			// 			})
			// 			.map(item => ({
			// 				...item,
			// 				month: getRandom(MONTHS),
			// 				name: getRandom(NAMES),
			// 				range: getRandom(RANGES)
			// 			}))
			//
			// 		resolve(events)
			// 	}, 400))
			// }
		},
		created () {
			this.fetchEvents()
				.then(events => {
					this.events = events.data.results
					this.$nextTick(() => {
						this.createSlider()
					})
				})
		}
	}
</script>

<style lang="scss" scoped>
	@import "../../styles/variables.scss";

	.events {
		overflow: hidden;

		background-color: $gray;
		padding: 50px 0 65px;
		&__headline {
			text-align: center;
			margin: 0;
			font-family: $libre-bold;
			font-size: 64px;
			color: $gold;
			line-height: 110px;
		}
		&__description {
			display: block;
			text-align: center;
			font-size: 16px;
			text-transform: uppercase;
			color: $gold;
			margin-bottom: 45px;
		}
		&__wrapper {
			width: 100%;
			display: flex;
			justify-content: space-between;
			margin-bottom: 40px;
			.event {
				&:first-child {
					margin-left: 0;
				}
				&:last-child {
					margin-right: 0;
				}
			}
		}
		&__arrow-wrapper {
			height: 100%;
			display: flex;
			align-items: center;

			position: absolute;
			top: 0;

			&--next {
				right: 0;

				@media (max-width: 575px) {
					right: -12px;
				}
			}

			&--prev {
				left: 0;

				@media (max-width: 575px) {
					left: -12px;
				}
			}
		}
		&__arrow {
			cursor: pointer;
			width: 64px;
			height: 64px;
			background: transparent;
			border: none;
			outline: none;
			-webkit-tap-highlight-color: transparent;
			&--left {
				background: url('/static/img/arrow-left.svg');
			}
			&--right {
				background: url('/static/img/arrow-right.svg');
			}
		}
		&__btn {
			margin: 0 auto;
			display: block;
			background-color: #fff;
			width: 100%;
			max-width: 295px;
			height: 50px;
			font-family: $lato-bold;
			font-size: 16px;
			color: $black;
			text-transform: uppercase;
			text-decoration: none;
			padding: 15px 0;
		}
	}

	@media (max-width: 575.98px) {
		.events {
			background-color: $gray;
			padding: 45px 0 50px;
			&__wrapper {
				margin-bottom: 25px;
			}
			&__headline {
				font-size: 42px;
				line-height: 50px;
			}
			&__description {
				font-size: 12px;
				margin-bottom: 25px;
			}
		}
	}

	// Small devices (landscape phones, 576px and up)
	@media (min-width: 576px) and (max-width: 767.98px) {
	}

	// Medium devices (tablets, 768px and up)
	@media (min-width: 768px) and (max-width: 991.98px) {
	}

	// Large devices (desktops, 992px and up)
	@media (min-width: 992px) and (max-width: 1199.98px) {
	}

	// Extra large devices (large desktops, 1200px and up)
	@media (min-width: 1200px) {
	}

</style>



// WEBPACK FOOTER //
// src/components/Home/EventsComponent.vue